<template>
    <rkm-table
        :fields="fields"
        :items="data.model.procedimentos"
        hide-filters
        hide-pagination
    >
        <template v-slot:cell(codigo)="{item}">
            {{formatProcedimento(item.codigo)}}
        </template>

        <template v-slot:cell(automatico)="{item}">
            {{item.automatico ? 'Sim' : 'Não'}}
        </template>

        <template v-slot:cell(materiais)="{item}">
            <div
                v-for="(material, i) in item.materiais"
                :key="i"
                class="text-nowrap"
            >
                {{ material.descricao }} (Quantidade: {{ material.quantidade }})
            </div>
        </template>

        <template v-slot:cell(actions)="{item, index}">
            <rkm-button
                :id="uniqueId(`local-curativo-${index}`)"
                small
            >
                <rkm-icon icon="comment" />
            </rkm-button>

            <rkm-popover
                :target="uniqueId(`local-curativo-${index}`)"
                placement="top"
                triggers="hover"
            >
                {{item.localCurativo ? item.localCurativo : 'Sem informação'}}
            </rkm-popover>

            <rkm-button
                :disabled="!!item.automatico"
                @click="destroy(index)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import {formats} from '@/mixins'

export default {
    data: () => ({
        fields: [
            {key: 'codigo', label: 'Código', sortable: true},
            {key: 'nome', label: 'Nome', sortable: true},
            {key: 'cidDescricao', label: 'CID', sortable: true},
            {key: 'quantidade', label: 'Quantidade', sortable: true},
            {key: 'automatico', label: 'Automático', sortable: true},
            {key: 'materiais', label: 'Material(is)', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o procedimento?', async () => {
                this.data.model.procedimentos.splice(index, 1)
            })
        },
    },
    mixins: [formats],
    props: {
        data: {type: Object, required: true},
    },
}
</script>